import "../css/blog-post.css";
import { tableOfContents, convertToSlug, add_link_hover, include_copied_text_badge } from './utils.js';

jQuery(document).ready(function () {
  console.log("blog-posts.js loaded");
  //postNavigation();
  //hideOnScroll();
  relatedPostsSlider();
  tableOfContents("h2,h3");
  document.addEventListener("scroll", processScroll);

  jQuery("nav.post-navigation a").each(function () {
    jQuery(this).css("top", "calc(50vh - " + jQuery(this).height() + "px/2)");
  });

  var headers = jQuery("#page_contents").find("h2,h3,h4,h5,h6");
  headers.each((index, element) => {
    add_link_hover(element);
  });
  include_copied_text_badge("#page_contents");
});

function postNavigation() {
  jQuery(".wp-block-post-navigation").each(function () {
    jQuery(this).mouseenter(function () {
      jQuery(this).toggleClass("show");
      //jQuery(this).find('a').show();
    });
    jQuery(this).mouseleave(function () {
      jQuery(this).toggleClass("show").delay(1500);
      //jQuery(this).find('a').hide();
    });
  });
}
// ToDo if not scrolling inside article, fade out elese fade in
function hideOnScroll() {
  var element = jQuery(".wp-block-post-navigation");
  var elementPos = jQuery(".wp-block-post-navigation-link")[0].clientHeight;
  // console.log("elementPos " + elementPos);
  var container = jQuery("#page_contents");
  var topPosition = jQuery(container).offset().top - elementPos;
  var bottomPosition =
    jQuery("#page_contents article").height() +
    jQuery("#page_contents article").offset().top;
  // console.log("bottomPosition " + bottomPosition);
  var absPosition = bottomPosition - elementPos * 2;
  // console.log("absPosition " + absPosition);
  jQuery(window).scroll(function () {
    if (
      jQuery(window).scrollTop() > topPosition &&
      jQuery(window).scrollTop() < absPosition
    ) {
      jQuery(element).addClass("show");
    } else {
      jQuery(element).removeClass("show");
    }
  });
}

/* Duplicate posts to avoid jumps on the scroll keyframes */
function relatedPostsSlider() {
  const $slider = jQuery("#related_posts_slider");
  const $track = $slider.find(".wp-block-post-template");
  const $items = $track.children("li");

  // In case there are not enough items to slide, the section is hidden
  if ($items.length >= 3) {
    $slider.parent().show();

    if ($slider.data("sliderReady")) {
      return;
    }

    $items.each(function () {
      jQuery(this).clone().appendTo($track);
    });

    const speedPxPerSecond = 80;
    let offset = 0;
    let rafId = null;
    let lastTime = 0;
    let isPaused = false;
    let isHovering = false;
    let isDragging = false;
    let activePointerId = null;
    let dragStartX = 0;
    let dragStartOffset = 0;
    let lastDragX = 0;
    let lastDragTime = 0;
    let momentumVelocity = 0;
    let isMomentumActive = false;
    const momentumDecayPerFrame = 0.92;
    const minMomentumVelocity = 10;

    function updatePauseState() {
      isPaused = isHovering || isDragging;
    }

    function getLoopWidth() {
      return Math.round($track[0].scrollWidth / 2);
    }

    function normalizeOffset() {
      const loopWidth = getLoopWidth();
      if (!loopWidth) return;

      offset = ((offset % loopWidth) + loopWidth) % loopWidth;
    }

    function render() {
      $track.css("transform", "translate3d(" + -offset + "px, 0, 0)");
    }

    function tick(timestamp) {
      if (!lastTime) lastTime = timestamp;

      const deltaSeconds = (timestamp - lastTime) / 1000;
      lastTime = timestamp;

      if (isMomentumActive && !isDragging) {
        offset += momentumVelocity * deltaSeconds;
        momentumVelocity *= Math.pow(momentumDecayPerFrame, deltaSeconds * 60);

        if (Math.abs(momentumVelocity) < minMomentumVelocity) {
          momentumVelocity = 0;
          isMomentumActive = false;
        }

        normalizeOffset();
        render();
      } else if (!isPaused && !isDragging) {
        offset += speedPxPerSecond * deltaSeconds;
        normalizeOffset();
        render();
      }

      rafId = window.requestAnimationFrame(tick);
    }

    function startAnimation() {
      if (rafId) return;
      rafId = window.requestAnimationFrame(tick);
    }

    function startDrag(clientX) {
      isDragging = true;
      isMomentumActive = false;
      momentumVelocity = 0;
      dragStartX = clientX;
      dragStartOffset = offset;
      lastDragX = clientX;
      lastDragTime = performance.now();
      updatePauseState();
      $slider.css("cursor", "grabbing");
    }

    function moveDrag(clientX) {
      if (!isDragging) return;

      const now = performance.now();
      const deltaX = clientX - lastDragX;
      const deltaTime = (now - lastDragTime) / 1000;

      if (deltaTime > 0) {
        // Smoothed velocity in px/s for momentum when user releases drag.
        const currentVelocity = -deltaX / deltaTime;
        momentumVelocity = momentumVelocity * 0.25 + currentVelocity * 0.75;
      }

      lastDragX = clientX;
      lastDragTime = now;

      const delta = clientX - dragStartX;
      offset = dragStartOffset - delta;
      normalizeOffset();
      render();
    }

    function endDrag() {
      if (Math.abs(momentumVelocity) >= minMomentumVelocity) {
        isMomentumActive = true;
      } else {
        momentumVelocity = 0;
        isMomentumActive = false;
      }

      isDragging = false;
      activePointerId = null;
      updatePauseState();
      $slider.css("cursor", "grab");
    }

    const sliderEl = $slider[0];
    $slider.css("-webkit-animation", "none");
    $slider.css("animation", "none");
    $slider.css("cursor", "grab");
    $slider.css("touch-action", "pan-y");

    sliderEl.addEventListener("mouseenter", function () {
      isHovering = true;
      updatePauseState();
      $slider.css("cursor", "grab");
    });

    sliderEl.addEventListener("mouseleave", function () {
      isHovering = false;
      updatePauseState();
    });

    sliderEl.addEventListener("pointerdown", function (e) {
      if (e.pointerType === "mouse" && e.button !== 0) return;

      activePointerId = e.pointerId;
      sliderEl.setPointerCapture(activePointerId);
      startDrag(e.clientX);
    });

    sliderEl.addEventListener("pointermove", function (e) {
      if (!isDragging || e.pointerId !== activePointerId) return;

      e.preventDefault();
      moveDrag(e.clientX);
    });

    sliderEl.addEventListener("pointerup", function (e) {
      if (e.pointerId !== activePointerId) return;

      sliderEl.releasePointerCapture(activePointerId);
      endDrag();
    });

    sliderEl.addEventListener("pointercancel", function (e) {
      if (e.pointerId !== activePointerId) return;

      endDrag();
    });

    startAnimation();
    $slider.data("sliderReady", true);
  }
}

let processScroll = () => {
  let scrollTop = jQuery(document).scrollTop();
  let scrollBottom =
    jQuery(document).height() -
    jQuery(window).height() -
    jQuery("footer").height() -
    jQuery("#related_posts_slider").height();
  let scrollPercent = (scrollTop / scrollBottom) * 100 + "%";
  // console.log("body " + scrollTop + ' / ' + scrollBottom + ' / ' + scrollPercent);

  jQuery("#reading_progress_bar").css("--scrollAmount", scrollPercent);
  console.log(scrollTop / scrollBottom >= 1);

  if (scrollTop / scrollBottom >= 1) {
    jQuery("#reading_progress_bar, #post-navigation").hide();
  } else {
    jQuery("#reading_progress_bar, #post-navigation").show();
  }
};
